import { forwardRef, useEffect, useState, type FC } from "react";
import { Button, Form, Input, Modal } from "rsuite";
import { Distributor } from "../../../models/distribution/distributor";
import { asyncLocalStorage } from "../../../utils/storage";

interface DistributorFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Distributor) => void;
  distributor?: Distributor;
}

const DistributorForm: FC<DistributorFormProps> = ({
  open,
  onClose,
  onSubmit,
  distributor,
}) => {
  const [data, setData] = useState<Distributor>({
    id: "",
    name: "",
    address: "",
    phone: "",
    website: "",
    email: "",
    contact_person: "",
    contact_position: "",
    contact_title: "",
    contact_note: "",
  });
  const [uploading, setUploading] = useState(false);
  const [uploadingCover, setUploadingCover] = useState(false);
  const [token, setToken] = useState("");

  

  useEffect(() => {
    asyncLocalStorage.getItem("token").then((token) => {
      setToken(token);
    });
  }, []);

  useEffect(() => {
    setData(
      distributor || {
        id: "",
        name: "",
        address: "",
        phone: "",
        website: "",
        email: "",
        contact_person: "",
        contact_position: "",
        contact_title: "",
        contact_note: "",
      }
    );
  }, [distributor]);

  const submit = () => {
    onSubmit(data);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="lg">
      <Modal.Header>
        <Modal.Title>
          {distributor ? "Update" : "Create"} Distributor
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form fluid layout="horizontal">
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="e.g. Distributor Name"
              value={data.name}
              onChange={(val) => setData({ ...data, name: val })}
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <Input
              as={"textarea"}
              name="address"
              placeholder="e.g. 123 Street, City, State, Zip"
              value={data.address}
              onChange={(val) => setData({ ...data, address: val })}
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <Input
              name="phone"
              placeholder="e.g. 123-456-7890"
              value={data.phone}
              onChange={(val) => setData({ ...data, phone: val })}
            />
          </div>
          <div className="form-group">
            <label>Website</label>
            <Input
              name="website"
              placeholder="e.g. https://example.com"
              value={data.website}
              onChange={(val) => setData({ ...data, website: val })}
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <Input
              name="email"
              placeholder="e.g. example@example.com"
              type="email"
              value={data.email}
              onChange={(val) => setData({ ...data, email: val })}
            />
          </div>
          <div className="form-group">
            <label>Contact Person</label>
            <Input
              name="contact_person"
              placeholder="e.g. John Doe"
              value={data.contact_person}
              onChange={(val) => setData({ ...data, contact_person: val })}
            />
          </div>
          <div className="form-group">
            <label>Contact Position</label>
            <Input
              name="contact_position"
              placeholder="e.g. Sales Manager"
              value={data.contact_position}
              onChange={(val) => setData({ ...data, contact_position: val })}
            />
          </div>
          <div className="form-group">
            <label>Contact Title</label>
            <Input
              name="contact_title"
              placeholder="e.g. Mr. or Ms."
              value={data.contact_title}
              onChange={(val) => setData({ ...data, contact_title: val })}
            />
          </div>
          <div className="form-group">
            <label>Contact Note</label>
            <Input
              name="contact_note"
              as="textarea"
              rows={3}
              placeholder="e.g. Additional information"
              value={data.contact_note}
              onChange={(val) => setData({ ...data, contact_note: val })}
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button appearance="primary" onClick={() => onSubmit(data!)}>
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default DistributorForm;
